module.exports = __webpack_public_path__ + "static/media/fan_room_2.fcdf2111.mp4";